import apiCall from '@/utils/apiCall';

const { lmFinished } = window;

/**
 * Creates user subscription
 *
 * @param   {object}  instance           Vue instance.
 * @param   {string}  plan           Subsciption plan id.
 * @param   {string}  payment_method  Payment method.
 * @param   {string}  coupon         Coupon code.
 *
 */
export default async (instance, plan, payment_method = '', coupon = '') => {
    const data = {
        plan,
        payment_method,
        coupon,
        lmref: lmFinished ? lmFinished() : null,
    };

    const response = await apiCall(instance, 'post', '/api/billing/subscriptions', data);

    if (201 === response.status) {
        await apiCall(instance, 'delete', '/api/user/meta', { data: ['payment_initialized'] });

        instance.$emit('process-to-step');
    } else {
        instance.cardError = response.data.message;
    }
};
